import React, { useEffect, useState } from 'react'
import './PagesManager.sass'
import { withRouter } from 'react-router-dom'
import { createForm } from '../../../../utils/newforms/createForm'
import getFieldRenderObject from '../../../../utils/newforms/render/getFieldRenderObject'
import FormRender from '../../../../utils/newforms/render/FormRender'
import ModulePanel from '../../../../ui/ModulePanel/ModulePanel'
import getDoc from '../../../../utils/db/getDoc'
import Button from '../../../../ui/Button/Button'
import isFormValid from '../../../../utils/newforms/validation/isFormValid'
import StatusMessage, { useStatusMessage } from '../../../../ui/StatusMessage/StatusMessage'
import getFormValues from '../../../../utils/newforms/getFormValues'
import { isNull } from 'lodash'
import { updateDoc } from '../../../../utils/db/updateDoc'
import Spinner from '../../../../ui/Spinner/Spinner'

function PagesManager({ ...router }) {
  const pageId = router.match.params.pageId

  const [form, setForm] = useState(null)
  const [showErrors] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [statusMessage, setStatusMessage] = useStatusMessage()

  useEffect(() => {
    if (pageId) {
      getDoc({ path: 'settings/pages/list', docId: pageId }).then((data) => {
        setForm(
          createForm({
            formPattern: new PageForm(),
            formData: data,
          })
        )
      })
    }
  }, [pageId])

  const onSubmit = async () => {
    if (!isFormValid({ form })) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      return setStatusMessage({
        show: true,
        type: 'fail',
        message: 'Будь ласка, заповніть усі поля форми',
        closeAfter: 5000,
      })
    }

    setIsLoading(true)

    const data = getFormValues({ form })
    const values = {
      ...data,
      updated: new Date(),
    }

    const opRef = updateDoc({
      path: 'settings/pages/list',
      docId: pageId,
      data: values,
    })

    opRef
      .then(() => {
        setIsLoading(false)
        setStatusMessage({
          show: true,
          type: 'success',
          message: 'Дані збережено',
          closeAfter: 5000,
        })
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })

      .catch((error) => {
        console.log('🚀 ~ onSubmit ~ error:', error)
      })
  }

  return (
    <div className="PagesManager">
      {!isNull(form) ? (
        <>
          {statusMessage.show && (
            <StatusMessage className="Site-StatusMessage" type={statusMessage.type} message={statusMessage.message} />
          )}
          <ModulePanel title={form.name.values}>
            <div className="MainInfo">
              <FormRender
                sections={[
                  {
                    fields: ['pageTitle', 'text'],
                  },
                ]}
                form={form}
                setForm={setForm}
                errors={showErrors}
              />
            </div>
          </ModulePanel>
          <div className="Buttons">
            <Button
              title="Зберегти"
              theme="solid"
              fill="accent"
              iconPosition="right"
              size={32}
              isLoading={isLoading}
              onClick={onSubmit}
            />
          </div>
        </>
      ) : (
        <Spinner type="module" />
      )}
    </div>
  )
}

class PageForm {
  constructor() {
    this.name = {
      field: { fieldId: 'name' },
      render: getFieldRenderObject({ isSystem: true }),
    }
    this.pageTitle = {
      field: {
        fieldId: 'pageTitle',
        fieldType: 'input',
        inputType: 'text',
        label: 'Заголовок сторінки',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.text = {
      field: {
        fieldId: 'text',
        fieldType: 'texteditor',
        label: 'Текст',
        required: false,
      },
      render: getFieldRenderObject(),
    }
    this.updated = {
      field: { fieldId: 'created', value: new Date() },
      render: getFieldRenderObject({ isSystem: true }),
    }
  }
}

export default withRouter(PagesManager)
